import {
    createTheme,
    createStyles,
    FormControl,
    Input,
    InputLabel,
    MuiThemeProvider,
    withStyles,
} from "@material-ui/core";
import * as React from "react";
import {AonColors} from "../../../../css/Colors";
import {FormattedMessage} from "react-intl";

const inputLabelStyles = createStyles({
    shrink: {
        display: "none",
    },
});

const inputStyles = createStyles({
    root: {
        "&:after": {
            borderBottomColor: AonColors.AonTealDark,
        },
        disabled: {},
        error: {},
        focused: {},
        paddingBottom: 0,
        marginTop: 0,
    },
});

const theme = createTheme({
    overrides: {
        MuiInput: {
            underline: {
                "&:hover:not($disabled):not($focused):not($error):before": {
                    borderBottom: "2px solid " + AonColors.AonTealDark,
                },
                "&:after": {
                    borderBottomColor: AonColors.AonTealDark,
                },
            },
            input: {
                paddingBottom: "5px",
            },
        },
    },
});

export const StyledInputLabel = withStyles(inputLabelStyles)(InputLabel);
export const StyledInput = (withStyles(inputStyles)(Input));

export interface ITextFieldComponentPropsFromParent {
    id?: string;
    name: string;
    className: string;
    type: string;
    fullWidth: boolean;
    value: string;
    handleChange: (e: any) => void;
    placeholder: string;
    renderRequired: boolean;
    submitClicked?: boolean;
}

export const TextFieldComponent = (props: ITextFieldComponentPropsFromParent) => {
    return (
        <FormControl>
            <StyledInputLabel>{props.placeholder}</StyledInputLabel>
            <MuiThemeProvider theme={theme}>
                <StyledInput
                    id={props.id}
                    name={props.name}
                    className={props.className}
                    type={props.type}
                    fullWidth={props.fullWidth}
                    value={props.value}
                    onChange={props.handleChange}
                />
            </MuiThemeProvider>
            {renderRequiredCaption(props.value, props.renderRequired, props.submitClicked)}
        </FormControl>
    );
};

const renderRequiredCaption = (text: string, renderRequired?: boolean, submitClicked?: boolean) => {
    const className = (submitClicked && text.length === 0)
        ? "common__required-caption-red"
        : "common__required-caption";

    return renderRequired
        ? <span className={className}>
            <FormattedMessage id="select.required"
                              defaultMessage="required" />
            </span>
        : null;
};
